var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#888888"}},[_vm._v("\n  Loading...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }